module.exports = __webpack_public_path__ + "img/people-group.def54848.svg";